import { Sliders } from "./cluetheory/Sliders";
import { storage } from "../lib/util/storage";
import { Log } from "../lib/util/Log";
var SliderPuzzle = Sliders.SliderPuzzle;
var SliderState = Sliders.SliderState;
var log = Log.log;
import { SC } from "../lib/settings";
export class CrowdSourcing {
    constructor(parent, server_url) {
        this.parent = parent;
        this.server_url = server_url;
        this.last_slider_state = new storage.Variable("crowdsourcing/last_slider_state", () => null);
    }
    endpoint(endpoint) {
        return `${this.server_url}/api/crowdsourcing/${endpoint}`;
    }
    async pushSlider(slider) {
        if (this.parent.settings.settings.crowdsourcing.slider_states) {
            const last = this.last_slider_state.get();
            const timestamp = Date.now();
            // Don't use the same theme twice in a row and apply a cooldown to sanitize data
            if (last && (last.theme == slider.theme || last.timestamp >= timestamp - 4500))
                return;
            const state = SliderPuzzle.getState(slider);
            // No longer the case! Sliders start with the blank in the bottom right. Reject if this isn't the case
            // if (state[24] != 24) return
            if (SliderState.equals(state, SliderState.SOLVED))
                return;
            this.last_slider_state.set({
                timestamp: timestamp,
                theme: slider.theme,
                state: state
            });
            const body = JSON.stringify({
                tiles: state,
                theme: slider.theme
            });
            log().log(`Adding slider ${body}`, "Crowdsourcing");
            fetch(this.endpoint("initial_slider_state"), {
                method: "POST",
                body: body,
                headers: {
                    "Content-type": "application/json; charset=UTF-8"
                }
            });
        }
    }
}
(function (CrowdSourcing) {
    CrowdSourcing.Settings = SC.object({
        slider_states: SC.boolean(false)
    });
})(CrowdSourcing || (CrowdSourcing = {}));
